import { render, staticRenderFns } from "./repairLocation.vue?vue&type=template&id=52f2365e"
import script from "./repairLocation.vue?vue&type=script&lang=js"
export * from "./repairLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports